//About section
import n4 from "../assets/images/obs-gynae/pregnency-care/normal-delivery/n4.jpg";
// ================= C-SECTION IMAGES =================
import c1 from "../assets/images/obs-gynae/pregnency-care/c-section-delivery/c-1.avif";
import c2 from "../assets/images/obs-gynae/pregnency-care/c-section-delivery/c-2.jpg";
import c3 from "../assets/images/obs-gynae/pregnency-care/c-section-delivery/c-3.jpg";
import c4 from "../assets/images/obs-gynae/pregnency-care/c-section-delivery/c4.jpg";

// ================= N-SECTION IMAGES =================
import n2 from "../assets/images/obs-gynae/pregnency-care/normal-delivery/n2.jpg";
import n3 from "../assets/images/obs-gynae/pregnency-care/normal-delivery/n3.jpeg";
import n1 from "../assets/images/obs-gynae/pregnency-care/normal-delivery/n1.jpg";
import n5 from "../assets/images/obs-gynae/pregnency-care/normal-delivery/n5.jpg";

// ================= P-SECTION IMAGES =================
import p1 from "../assets/images/obs-gynae/pregnency-care/painless-delivery/p1.jpg";
import p2 from "../assets/images/obs-gynae/pregnency-care/painless-delivery/p2.jpg";
import p3 from "../assets/images/obs-gynae/pregnency-care/painless-delivery/p3.png";
import p4 from "../assets/images/obs-gynae/pregnency-care/painless-delivery/p4.webp";

// ================= Pc-SECTION IMAGES =================
import pc1 from "../assets/images/obs-gynae/pregnency-care/postpartum-care/pc2.jpg";
import pc2 from "../assets/images/obs-gynae/pregnency-care/postpartum-care/pc3.jpg";
import pc3 from "../assets/images/obs-gynae/pregnency-care/postpartum-care/pc1.jpg";
import pc4 from "../assets/images/obs-gynae/pregnency-care/postpartum-care/pc4.jpg";

// ================= Pr-SECTION IMAGES =================
import pr1 from "../assets/images/obs-gynae/pregnency-care/normal-delivery/n1.jpg";
import pr2 from "../assets/images/obs-gynae/pregnency-care/normal-delivery/n2.jpg";
import pr3 from "../assets/images/obs-gynae/pregnency-care/pr3.jpg";
import pr4 from "../assets/images/obs-gynae/pregnency-care/pr4.webp";

// ================= vp-SECTION IMAGES =================
import vp1 from "../assets/images/obs-gynae/pregnency-care/vaccination/vp1.jpg";
import vp2 from "../assets/images/obs-gynae/pregnency-care/vaccination/vp2.jpg";
import vp3 from "../assets/images/obs-gynae/pregnency-care/vaccination/vp3.webp";
import vp4 from "../assets/images/obs-gynae/pregnency-care/vaccination/vp4.webp";

// ================= vp-SECTION IMAGES =================
import f1 from "../assets/images/obs-gynae/gynecology/fibroid-treatment/f1.jpg";
import f2 from "../assets/images/obs-gynae/gynecology/fibroid-treatment/f2.jpg";
import f3 from "../assets/images/obs-gynae/gynecology/fibroid-treatment/f3.webp";
import f4 from "../assets/images/obs-gynae/gynecology/fibroid-treatment/f4.jpg";

// ================= fas-SECTION IMAGES =================
import fa1 from "../assets/images/obs-gynae/gynecology/infections-stis/fa1.jpg";
import fa2 from "../assets/images/obs-gynae/gynecology/infections-stis/fa2.jpg";
import fa3 from "../assets/images/obs-gynae/gynecology/infections-stis/fa3.jpg";
import fa4 from "../assets/images/obs-gynae/gynecology/infections-stis/fa4.jpg";

// ================= fb-SECTION IMAGES =================
import fb1 from "../assets/images/obs-gynae/gynecology/laparoscopic-surgery/fb1.jpg";
import fb3 from "../assets/images/obs-gynae/gynecology/laparoscopic-surgery/fb3.jpg";
import fb2 from "../assets/images/obs-gynae/gynecology/laparoscopic-surgery/fb2.jpg";
import fb4 from "../assets/images/obs-gynae/gynecology/laparoscopic-surgery/fb4.jpg";

// ================= fc-SECTION IMAGES =================
import fc1 from "../assets/images/obs-gynae/gynecology/menstrual-health/fc1.jpg";
import fc2 from "../assets/images/obs-gynae/gynecology/menstrual-health/fc2.jpg";
import fc3 from "../assets/images/obs-gynae/gynecology/menstrual-health/fc3.jpg";
import fc4 from "../assets/images/obs-gynae/gynecology/menstrual-health/fc4.jpg";

// ================= fd-SECTION IMAGES =================
import fd1 from "../assets/images/obs-gynae/gynecology/pcos-treatment/fd1.jpg";
import fd2 from "../assets/images/obs-gynae/gynecology/pcos-treatment/fd2.jpg";
import fd3 from "../assets/images/obs-gynae/gynecology/pcos-treatment/fd3.jpg";
import fd4 from "../assets/images/obs-gynae/gynecology/pcos-treatment/fd4.jpg";

// ================= pa-SECTION IMAGES =================
import pa1 from "../assets/images/obs-gynae/gynecology/pelvic-pain-breast-exams-pap-smears/pa1.jpg";
import pa2 from "../assets/images/obs-gynae/gynecology/pelvic-pain-breast-exams-pap-smears/pa2.jpg";
import pa3 from "../assets/images/obs-gynae/gynecology/pelvic-pain-breast-exams-pap-smears/pa3.jpg";
import pa4 from "../assets/images/obs-gynae/gynecology/pelvic-pain-breast-exams-pap-smears/pa4.jpg";


import hyst1 from "../assets/images/obs-gynae/gynecology/Hysterectomy/hyst1.jpeg";
import hyst2 from "../assets/images/obs-gynae/gynecology/Hysterectomy/hyst2.jpeg";
import hyst3 from "../assets/images/obs-gynae/gynecology/Hysterectomy/hyst3.jpeg";

import myo1 from "../assets/images/obs-gynae/gynecology/Myomectomy/myo1.jpeg";
import myo2 from "../assets/images/obs-gynae/gynecology/Myomectomy/myo2.jpeg";
import myo3 from "../assets/images/obs-gynae/gynecology/Myomectomy/myo3.jpeg";

import colpo1 from "../assets/images/obs-gynae/gynecology/Colposcopy/colpo1.jpeg";
import colpo2 from "../assets/images/obs-gynae/gynecology/Colposcopy/colpo2.jpeg";
import colpo3 from "../assets/images/obs-gynae/gynecology/Colposcopy/colpo3.jpeg";

import cryo1 from "../assets/images/obs-gynae/gynecology/Cryo cautery/cryo1.jpeg";
import cryo2 from "../assets/images/obs-gynae/gynecology/Cryo cautery/cryo1.jpeg";
import cryo3 from "../assets/images/obs-gynae/gynecology/Cryo cautery/cryo1.jpeg";



export const serviceDetailsData = {


  "c-section-delivery": {
    title: "C-Section Delivery",
    seoTitle:
      "C-Section Delivery - Dr Vibha  | Safe Cesarean Delivery Care",

    seoDescription:
      "Safe and expert C-section delivery at Dr Vibha’s . Advanced surgical care, experienced doctors, and complete support for a healthy mother and baby.",

    seoKeywords:
      "c-section delivery, cesarean delivery, cesarean section, pregnancy delivery, maternity care, gynecologist, Dr Vibha ",

    intro:
      "A cesarean section (C-section) is a surgical procedure to deliver a baby through incisions made in the mother’s abdomen and uterus. It is recommended when a normal vaginal birth may pose risks to the mother or baby.",

    heroExtraText:
      "Thanks to modern surgical techniques, advanced anesthesia, and improved post-operative care, C-sections today are safe and commonly performed procedures, ensuring the safety of both mother and baby.",

    heroImage: c1,

    sections: [
      {
        medicalheading: "Medical Reasons for a C-Section",
        heading: "Medical Reasons for a C-Section",

        description:
          "Doctors may recommend a C-section for several medical or pregnancy-related concerns. Some of the most frequent include:",

        para: "Doctors may recommend a C-section for several medical or pregnancy-related concerns. Some of the most frequent include:",

        points: [
          "Breech or transverse: position where the baby is not head-down",
          "Placenta previa: where the placenta covers the cervix",
          "Fetal distress: due to reduced oxygen supply or abnormal heart rate",
          "Multiple pregnancies: such as twins or triplets",
          "History of previous C-section: repeat procedure may be safer",
          "Maternal health issues: hypertension, cardiac disease, or infections",
        ],

        image: c4,
      },

      {
        heading: "What Happens During The Procedure",

        description:
          "A scheduled C-section is usually performed under spinal or epidural anesthesia, allowing the mother to stay conscious while remaining pain-free throughout the delivery.",

        points: [
          "Preparation – IV line, anesthesia, and catheter placement.",
          "Incision – A horizontal cut made just above the pelvic area.",
          "Delivery – Baby is gently lifted out through the uterus.",
          "Closure – Uterus and abdominal layers are carefully stitched.",
        ],

        image: c2,
      },

      {
        heading: "Recovery And Postnatal Care",

        description:
          "Healing from a C-section generally takes longer than vaginal delivery. Most women require 2–4 days in the hospital and several weeks of rest at home.",

        points: [
          "Adequate rest – Avoid heavy lifting for 6–8 weeks.",
          "Pain relief medications – Safe medicines prescribed by doctor.",
          "Incision care – Keep wound clean and dry.",
          "Healthy diet – Proper nutrition supports healing.",
          "Follow-up visits – Regular checkups ensure recovery progress.",
          "Emotional support – Family care helps faster recovery.",
        ],

        image: c3,
      },
    ],

    doctorSection: {
      heading:
        "Why Choose Dr. Vibha’s Gynecology & Fertility  For C-Section Delivery",

      para: "Our  offers safe, modern, and patient-centered cesarean delivery care with experienced obstetricians, advanced facilities, and complete maternal and neonatal support.",

      points: [
        "Skilled obstetric and surgical specialists",
        "24×7 emergency assistance with fetal monitoring",
        "Modern operation theaters with neonatal care",
        "Personalized birth planning and support",
        "Complete post-delivery recovery care",
        "Comfortable and safe hospital environment",
      ],

      image: n3,
    },
  },

  "normal-delivery": {
    title: "Normal Delivery",
    seoTitle:
      "Normal Delivery - Dr Vibha’s  | Safe & Natural Childbirth Care",

    seoDescription:
      "Expert normal delivery care at Dr Vibha’s  with experienced doctors, personalized pregnancy support, and safe childbirth for mother and baby.",

    seoKeywords:
      "normal delivery, natural childbirth, pregnancy delivery, maternity care, vaginal delivery, gynecologist, Dr Vibha ",

    intro:
      "Normal delivery means giving birth naturally through the vaginal canal without surgery. It is the most common and preferred way of childbirth when there are no risks to the mother or baby.",

    heroExtraText: `The body works with nature during this process—uterine contractions help push the baby out safely. For healthy pregnancies, normal delivery is often the safest method, allowing mothers to recover faster and offering many health benefits for the baby.<br/><br/>
     At Dr. Vibha’s Gynecology & Fertility , we support natural birth through safe medical practices, personalized care, and emotional guidance.`,

    heroImage: n1,

    sections: [
      {
        medicalheading: "Benefits of Normal Delivery",
        heading: "Benefits of Normal Delivery",

        para: "Choosing vaginal delivery provides many health advantages for both mother and baby:",

        description:
          "Choosing vaginal delivery provides many health advantages for both mother and baby:",

        points: [
          "Quick Recovery: Mothers can usually walk and start light activities within a few hours.",
          "Lower Risk of Infection: No surgical incision reduces complications.",
          "Immediate Bonding: Skin-to-skin contact helps breastfeeding.",
          "Stronger Baby Immunity: Natural exposure supports gut health.",
          "Shorter Hospital Stay: Most mothers go home within 1–2 days.",
        ],

        image: n2,
      },

      {
        heading: "How to Prepare for a Normal Delivery",

        description:
          "Proper preparation helps make childbirth smoother and more comfortable. At our , we guide expecting mothers with:",

        points: [
          "Prenatal Exercises – Yoga, breathing techniques, and stretches.",
          "Healthy Nutrition – Balanced diet for mother and baby.",
          "Regular Check-ups – Monitoring baby’s growth and position.",
          "Labor Education – Pain relief and pushing techniques.",
        ],

        image: n5,
      },

      {
        heading: "What Happens During Labor?",

        description:
          "Labor usually occurs in stages and can last several hours. A normal delivery typically involves:",

        points: [
          "Early Labor – Mild contractions and gradual cervical opening.",
          "Active Labor – Stronger and frequent contractions.",
          "Transition Phase – Most intense stage before pushing.",
          "Delivery – Baby is safely born with medical guidance.",
          "Afterbirth – Placenta delivery and newborn care.",
        ],

        image: n4,
      },
    ],

    doctorSection: {
      heading:
        "Why Choose Dr. Vibha’s Gynecology & Fertility  for Normal Delivery",

      para: "At Dr. Vibha’s , we make childbirth a safe, comfortable, and memorable journey. Here’s what makes us trusted by so many families:",

      points: [
        "Highly experienced gynecology team focused on natural birthing",
        "24×7 labor monitoring and emergency support",
        "Modern and comfortable labor rooms",
        "Personalized birth plans for every mother",
        "Continuous emotional and medical support",
        "Comprehensive postnatal care and breastfeeding guidance",
      ],

      image: n3,
    },
  },

  "painless-delivery": {
    title: "Painless Delivery",
    seoTitle:
      "Painless Delivery - Dr Vibha’s  | Comfortable & Safe Childbirth",

    seoDescription:
      "Experience painless delivery at Dr Vibha’s  with advanced epidural techniques, expert doctors, and complete maternity care for a safe and comfortable childbirth.",

    seoKeywords:
      "painless delivery, epidural delivery, painless normal delivery, pregnancy care, maternity care, gynecologist, Dr Vibha ",

    intro: `Painless delivery is a childbirth method where epidural anesthesia is used to reduce or completely remove the pain of labor. The mother stays awake, alert, and actively involved in the birth process, but without the intense discomfort usually felt during contractions. This option provides a safer and more comfortable birthing experience while keeping the baby’s health secure.`,

    heroExtraText: `At Dr. Vibha’s Gynecology & Fertility , we know every woman’s birthing experience is unique. That’s why we provide personalized pain relief options – including epidurals – so mothers can welcome their baby with confidence and peace of mind.`,

    heroImage: p1,

    sections: [
      {
        medicalheading: "How Does Epidural Work in Labor?",
        heading: "How Does Epidural Work in Labor?",

        para: "An epidural is a form of regional anesthesia given through a small tube placed in the lower back. It numbs the lower half of the body but allows the mother to remain conscious and responsive throughout delivery.",

        description:
          "The epidural blocks pain signals from reaching the brain while allowing the mother to stay alert and actively participate in childbirth.",

        points: [
          "Administered during active labor when cervix is dilated.",
          "Pain relief begins within 10–15 minutes.",
          "Contractions are felt as pressure, not pain.",
          "Continuous monitoring by trained anesthesiologist.",
          "Dosage adjusted based on comfort and labor progress.",
        ],

        image: p2,
      },

      {
        heading: "Benefits of Painless Delivery",

        description:
          "Choosing painless delivery makes childbirth more comfortable and less stressful, especially for first-time mothers.",

        points: [
          "Reduces labor pain significantly.",
          "Helps mother stay calm and relaxed.",
          "Provides more energy for pushing.",
          "Improves overall birth experience.",
          "Reduces stress and anxiety during labor.",
          "Supports smoother vaginal delivery.",
        ],

        image: p3,
      },

      {
        heading: "Is Painless Delivery Safe for Mother and Baby?",

        description:
          "Epidural-assisted delivery is a safe and widely used method worldwide. With proper medical supervision, risks are minimal.",

        points: [
          "Safe for both mother and baby.",
          "Mother remains conscious and alert.",
          "Allows natural pushing during delivery.",
          "Side effects are rare and manageable.",
          "Constant monitoring ensures safety.",
          "Used globally as a standard pain relief method.",
        ],

        image: p4,
      },
    ],

    doctorSection: {
      heading:
        "Why Choose Dr. Vibha’s Gynecology & Fertility  for Painless Delivery?",

      para: "At Dr. Vibha’s , we ensure painless delivery is safe, comfortable, and empowering with expert care and modern facilities.",

      points: [
        "Expert gynecologists and anesthesiologists",
        "Safe epidural administration techniques",
        "24×7 monitoring of mother and baby",
        "Advanced and comfortable labor rooms",
        "Personalized pain relief care plans",
        "Complete post-delivery support",
      ],

      image: n3,
    },
  },

  "postpartum-care": {
    title: "Postpartum Care",
    seoTitle:
      "Postpartum Care - Dr Vibha’s  | Post Delivery Mother & Baby Care",

    seoDescription:
      "Comprehensive postpartum care at Dr Vibha’s  to support recovery after delivery. Expert care for mother’s health, healing, and newborn wellbeing.",

    seoKeywords:
      "postpartum care, post delivery care, after delivery care, maternal care, postnatal care, maternity care, Dr Vibha ",

    intro: `Postpartum care is the medical and emotional support a woman receives after childbirth. Often called the “fourth trimester, this phase begins right after delivery and usually lasts 6 to 8 weeks. During this time, the body heals, hormones adjust, and mothers adapt to new routines with their baby.`,

    heroExtraText: `At Dr. Vibha’s Gynecology & Fertility, we understand that postpartum is a beautiful yet challenging journey. Our dedicated team provides complete postnatal care, ensuring mothers recover smoothly — physically, emotionally, and mentally.`,

    heroImage: pc1,

    sections: [
      {
        medicalheading: "Physical Recovery After Childbirth",
        heading: "Physical Recovery After Childbirth",

        para: "Whether you’ve had a normal delivery or a C-section, your body needs proper care and medical guidance to heal safely.",

        description:
          "Our  provides complete physical recovery support to ensure safe healing and restore strength.",

        points: [
          "Monitoring of stitches and incision healing",
          "Guidance on managing postpartum bleeding (Lochia)",
          "Pain management and recovery support",
          "Personalized nutrition plans for faster healing",
          "Postnatal exercises to regain strength",
          "Regular health check-ups and recovery tracking",
        ],

        image: pc2,
      },

      {
        heading: "Breastfeeding Guidance & Newborn Support",

        description:
          "Our team provides expert support to help mothers feel confident and comfortable while caring for their newborn.",

        points: [
          "Lactation counseling and breastfeeding techniques",
          "Support for milk supply and feeding routines",
          "Guidance on newborn hygiene and cord care",
          "Safe swaddling and sleep positioning techniques",
          "Help with breast discomfort or feeding challenges",
          "Education on baby nutrition and growth monitoring",
        ],

        image: pc3,
      },

      {
        heading: "Emotional & Mental Health Support",

        description:
          "Emotional wellbeing is essential after childbirth. We provide support to help mothers adjust to physical and emotional changes.",

        points: [
          "Emotional health monitoring and counseling",
          "Support for managing stress and anxiety",
          "Guidance for postpartum mood changes",
          "Professional counseling if required",
          "Family and emotional support guidance",
          "Helping mothers build confidence in newborn care",
        ],

        image: pc4,
      },
    ],

    doctorSection: {
      heading:
        "Why Choose Dr. Vibha’s Gynecology & Fertility  for Postpartum Care?",

      para: "We continue to care for you even after delivery, ensuring complete recovery, comfort, and confidence during motherhood.",

      points: [
        "Continuous care from experienced gynecologists",
        "Dedicated postnatal recovery support",
        "Expert breastfeeding and newborn care guidance",
        "Personalized recovery and nutrition plans",
        "Modern facilities and compassionate care",
        "Complete physical and emotional support",
      ],

      image: n3,
    },
  },

  "pregnancy-care": {
    title: "Pregnancy Care",
    seoTitle:
      "Pregnancy Care - Dr Vibha’s  | Complete Maternity & Prenatal Care",

    seoDescription:
      "Expert pregnancy care at Dr Vibha’s  with regular checkups, prenatal care, and personalized support to ensure a healthy mother and baby.",

    seoKeywords:
      "pregnancy care, prenatal care, maternity care, antenatal care, pregnancy checkup, gynecologist, Dr Vibha ",

    intro: `Pregnancy care — also called antenatal care — is the continuous medical support, lifestyle guidance, and emotional care a woman receives during her pregnancy. It begins when pregnancy is confirmed and continues until delivery, ensuring the health and safety of both mother and baby.`,

    heroExtraText: `At Dr. Vibha’s Gynecology & Fertility , we walk with every mother through each trimester, offering medical care along with empathy, education, and encouragement. Our goal is to make your pregnancy journey safe, confident, and joyful.`,

    heroImage: pr1,

    sections: [
      {
        medicalheading: "What Does Our Pregnancy Care Include?",
        heading: "What Does Our Pregnancy Care Include?",

        para: "We create personalized care plans designed according to each mother’s unique health needs.",

        description:
          "Our antenatal program focuses on complete monitoring, early detection of risks, and continuous emotional support.",

        points: [
          "Routine check-ups to monitor blood pressure and baby’s growth",
          "Ultrasound scans for fetal development tracking",
          "Blood and urine tests for early detection of complications",
          "Personalized nutrition and supplement guidance",
          "Birth preparation and parenting education",
          "Emotional wellness and stress management support",
        ],

        image: pr2,
      },

      {
        heading: "Why Is Regular Pregnancy Care Important?",

        description:
          "Consistent antenatal visits help reduce risks and ensure safe pregnancy progression.",

        points: [
          "Reduces risk of pregnancy-related complications",
          "Ensures proper fetal growth and development",
          "Supports healthy maternal weight gain",
          "Prepares mothers physically and emotionally for delivery",
          "Improves chances of smoother postpartum recovery",
          "Builds confidence through medical guidance",
        ],

        image: pr3,
      },

      {
        heading: "Your Pregnancy Journey with Dr. Vibha’s",

        description:
          "We provide trimester-based pregnancy care to ensure support at every stage.",

        points: [
          "First Trimester (0–13 weeks): Pregnancy confirmation, early scans, and due date calculation",
          "Initial Blood Tests: Screening for anemia, thyroid function, blood group, and infections",
          "Nutrition Planning: Personalized diet and supplements like folic acid for baby’s development",
          "Ultrasound Monitoring: Early scans to confirm fetal heartbeat and healthy growth",
          "Second Trimester (14–27 weeks): Detailed anomaly scan to check baby’s organs and structure",
          "Gestational Diabetes Screening: Tests to ensure healthy blood sugar levels during pregnancy",
          "Regular Health Monitoring: Tracking blood pressure, weight, and overall maternal health",
          "Third Trimester (28 weeks–Delivery): Growth scans and fetal wellbeing assessments",
          "Birth Planning: Guidance for normal delivery, painless delivery, or C-section preparation",
          "Breastfeeding & Postnatal Preparation: Education on newborn care, breastfeeding, and recovery",
        ],

        image: pr4,
      },
    ],

    doctorSection: {
      heading:
        "Why Choose Dr. Vibha’s Gynecology & Fertility  for Pregnancy Care?",

      para: "Pregnancy is not just a medical journey — it’s a life-changing experience. At our, every mother receives compassionate care, personal attention, and trusted medical guidance.",

      points: [
        "Experienced gynecologist for both routine and high-risk pregnancies",
        "Modern diagnostic and scanning facilities under one roof",
        "Patient-first approach with complete counseling",
        "Holistic support including nutrition and prenatal exercise guidance",
        "24×7 on-call assistance for urgent concerns",
        "Comprehensive planning for normal, painless, or C-section delivery",
      ],

      image: n3,
    },
  },

  "vaccination": {
    title: "Vaccination in Pregnancy",
    seoTitle:
      "Vaccination in Pregnancy - Dr Vibha’s  | Safe Maternal Immunization",

    seoDescription:
      "Ensure maternal and fetal health with expert vaccination in pregnancy at Dr Vibha’s . Protect both mother and baby with safe and timely vaccines.",

    seoKeywords:
      "vaccination in pregnancy, maternal vaccination, pregnancy vaccines, safe pregnancy, prenatal care, Dr Vibha ",

    intro: `Vaccination is one of the safest and most effective ways to protect both the mother and her baby from serious infections. During pregnancy, a woman’s immune system changes, making her more vulnerable to illness. Vaccines help build protective antibodies that also pass to the baby, providing early protection after birth.`,

    heroExtraText: `At Dr. Vibha’s Gynecology & Fertility , we follow medically approved vaccination protocols to ensure complete safety for both mother and baby throughout pregnancy.`,

    heroImage: vp1,

    sections: [
      {
        medicalheading: "Recommended Vaccines for Expectant Mothers",
        heading: "Recommended Vaccines for Expectant Mothers",

        para: "We follow globally accepted medical guidelines to ensure safe and timely vaccination during pregnancy.",

        description:
          "Maternal vaccination protects both mother and baby from preventable infections.",

        points: [
          "Tdap Vaccine: Protects against tetanus, diphtheria, and whooping cough",
          "Influenza Vaccine: Prevents serious flu-related complications",
          "COVID-19 Vaccine: Reduces risk of severe infection and protects baby",
          "Tetanus Injection: Essential for preventing neonatal tetanus",
          "Vaccination timing planned based on pregnancy stage",
          "Protection passed to baby through maternal antibodies",
        ],

        image: vp2,
      },

      {
        heading: "Safety and Myths About Vaccination in Pregnancy",

        description:
          "Vaccines recommended during pregnancy are medically tested and safe for both mother and baby.",

        points: [
          "Vaccines do not harm fetal development",
          "Maternal vaccination protects newborn after birth",
          "Side effects are mild and temporary",
          "Vaccines reduce risk of severe infections",
          "Medical supervision ensures complete safety",
          "Only approved vaccines are administered",
        ],

        image: vp3,
      },

      {
        heading: "Our Commitment to Safe Maternal Vaccination",

        description:
          "We ensure every vaccination is provided safely with proper monitoring and guidance.",

        points: [
          "Use of approved and certified vaccines only",
          "Proper medical assessment before vaccination",
          "Monitoring after vaccination for safety",
          "Complete vaccination record maintenance",
          "Personalized vaccination schedule planning",
          "Expert medical supervision at every step",
        ],

        image: vp4,
      },
    ],

    doctorSection: {
      heading:
        "Why Choose Dr. Vibha’s Gynecology & Fertility  for Pregnancy Vaccination?",

      para: "We provide safe, evidence-based maternal vaccination with expert care and monitoring.",

      points: [
        "Experienced gynecologists trained in maternal vaccination",
        "International safety guidelines followed",
        "High-quality approved vaccines used",
        "Personalized vaccination planning",
        "Safe and hygienic clinical environment",
        "Complete pregnancy and vaccination support",
      ],

      image: n3,
    },
  },

  // Gynecology -----------------------------------------//

  "fibroid-treatment": {
    title: "Fibroid Treatment",
    seoTitle:
      "Fibroid Treatment - Dr Vibha’s  | Uterine Fibroid Care & Management",

    seoDescription:
      "Expert fibroid treatment at Dr Vibha’s  for safe and effective management of uterine fibroids. Advanced care with minimally invasive procedures.",

    seoKeywords:
      "fibroid treatment, uterine fibroid care, fibroid removal, gynecology treatment, minimally invasive fibroid surgery, Dr Vibha ",

    intro: `Uterine fibroids are non-cancerous growths that develop in or around the uterus. They are very common in women of reproductive age and can vary in size. While some fibroids cause no symptoms, others may lead to heavy bleeding, pelvic pain, or fertility challenges.`,

    heroExtraText: `At Dr. Vibha’s Gynecology & Fertility , we provide accurate diagnosis and personalized fibroid treatment plans that protect your health, comfort, and future fertility.`,

    heroImage: f1,

    sections: [
      {
        medicalheading: "Symptoms That May Indicate Fibroids",
        heading: "Symptoms That May Indicate Fibroids",

        para: "Fibroids may not always cause symptoms, but when they do, early medical care can prevent complications.",

        description: "Common signs and symptoms include:",

        points: [
          "Heavy or prolonged menstrual bleeding",
          "Pelvic pressure or abdominal bloating",
          "Frequent urination due to bladder pressure",
          "Pain during intercourse",
          "Lower back or pelvic pain",
          "Irregular menstrual cycles",
          "Difficulty conceiving",
          "Recurrent miscarriages in some cases",
          "Abdominal swelling or enlargement",
          "Fatigue caused by heavy bleeding",
        ],

        image: f2,
      },

      {
        heading: "Advanced Diagnosis of Fibroids",

        description:
          "Accurate diagnosis helps determine the size, location, and number of fibroids to plan effective treatment.",

        points: [
          "Pelvic examination to detect uterine enlargement",
          "Ultrasound scan for quick and safe fibroid detection",
          "MRI scan for detailed fibroid mapping",
          "Hysteroscopy to view fibroids inside uterus",
          "Fertility assessment if conception is affected",
          "Hormonal evaluation if required",
        ],

        image: f3,
      },

      {
        heading: "Treatment Options for Fibroids",

        description:
          "Treatment depends on symptoms, fibroid size, and future pregnancy plans.",

        points: [
          "Medication to control bleeding and pain",
          "Hormonal therapy to regulate menstrual cycle",
          "Minimally invasive laparoscopic fibroid removal",
          "Hysteroscopic fibroid removal without external cuts",
          "Myomectomy to preserve fertility",
          "Non-surgical monitoring for small fibroids",
          "Advanced surgical treatment for large fibroids",
          "Personalized treatment based on patient needs",
        ],

        image: f4,
      },

      {
        heading: "Fertility Preservation and Recovery",

        description:
          "Our goal is to treat fibroids while protecting your reproductive health and ensuring faster recovery.",

        points: [
          "Fertility-preserving treatment options available",
          "Advanced minimally invasive surgical techniques",
          "Faster healing and reduced recovery time",
          "Minimal pain and scarring",
          "Improved chances of conception after treatment",
          "Complete post-treatment monitoring and care",
        ],
      },
    ],

    doctorSection: {
      heading: "Why Choose Dr. Vibha’s  for Fibroid Treatment?",

      para: "We provide advanced fibroid care focused on safety, comfort, and fertility preservation.",

      points: [
        "Experienced gynecologist specialized in fibroid treatment",
        "Advanced ultrasound and diagnostic facilities",
        "Minimally invasive treatment options available",
        "Fertility-preserving surgical expertise",
        "Personalized care and treatment planning",
        "Complete support from diagnosis to recovery",
      ],

      image: n3,
    },
  },

  "infections-stis": {
    title: "Infections & STIs Care",
    seoTitle:
      "Infections & STIs Care - Dr Vibha’s  | Expert Gynecological Treatment",

    seoDescription:
      "Get expert care for infections and STIs at Dr Vibha’s . Safe, confidential, and effective treatment to protect reproductive health and overall wellbeing.",

    seoKeywords:
      "infections treatment, STIs care, gynecological infections, sexually transmitted infections, reproductive health, Dr Vibha ",

    intro: `Sexually transmitted infections (STIs) and reproductive tract infections are more common than many women realize. Some infections may not show symptoms in the early stages, but if left untreated, they can affect fertility, pregnancy, and overall reproductive health.`,

    heroExtraText: `At Dr. Vibha’s Gynecology & Fertility , we focus on early detection, confidential testing, and personalized treatment plans to protect your long-term health and well-being.`,

    heroImage: fa1,

    sections: [
      {
        medicalheading: "Common Types of Infections We Treat",
        heading: "Common Types of Infections We Treat",

        para: "Our  diagnoses and treats a wide range of reproductive tract and sexually transmitted infections.",

        description:
          "These include bacterial, viral, fungal, and parasitic infections that may impact reproductive health.",

        points: [
          "Chlamydia and Gonorrhea",
          "Bacterial Vaginosis",
          "Human Papillomavirus (HPV)",
          "Genital Herpes",
          "HIV screening and counseling",
          "Trichomoniasis",
          "Yeast (Fungal) Infections",
          "Pelvic Inflammatory Disease (PID)",
        ],

        image: fa2,
      },

      {
        heading: "Symptoms You Shouldn’t Ignore",

        description:
          "Some infections cause noticeable symptoms, while others remain silent. Seek medical care if you experience:",

        points: [
          "Unusual vaginal discharge with odor or color change",
          "Burning sensation during urination",
          "Pelvic or lower abdominal pain",
          "Genital sores, blisters, or warts",
          "Pain or bleeding after intercourse",
          "Persistent itching or irritation",
          "Irregular bleeding between periods",
          "Fever associated with pelvic discomfort",
          "Pain during intercourse",
          "Even without symptoms, regular screening is recommended for sexually active women",
        ],

        image: fa3,
      },

      {
        heading: "Our Supportive & Confidential Care Approach",

        description:
          "We understand that discussing infections can feel uncomfortable. Our  ensures privacy, dignity, and compassionate care at every step.",

        points: [
          "Private and respectful consultations",
          "Confidential testing and reports",
          "Accurate diagnosis using advanced lab methods",
          "Targeted medication based on infection type",
          "Partner testing and treatment guidance",
          "Follow-up care to prevent recurrence",
          "Education on safe practices and prevention",
          "Emotional support and counseling if needed",
        ],

        image: fa4,
      },
    ],

    doctorSection: {
      heading: "Why Choose Dr. Vibha’s  for Infections & STI Care?",

      para: "We provide safe, confidential, and medically advanced care to protect your reproductive health.",

      points: [
        "Experienced gynecology team",
        "Modern diagnostic and laboratory facilities",
        "Strict patient confidentiality",
        "Evidence-based treatment protocols",
        "Complete infection management and follow-up",
        "Comprehensive women’s health support",
      ],

      image: n3,
    },
  },

  "laparoscopic-surgery": {
    title: "Laparoscopic Surgery",
    seoTitle:
      "Laparoscopic Surgery - Dr Vibha’s  | Minimally Invasive Gynecological Surgery",

    seoDescription:
      "Advanced laparoscopic surgery at Dr Vibha’s  for safe and precise treatment of gynecological conditions. Minimally invasive procedures for faster recovery.",

    seoKeywords:
      "laparoscopic surgery, minimally invasive surgery, gynecological surgery, laparoscopy treatment, fibroid removal, Dr Vibha ",

    intro: `Laparoscopic surgery, also known as minimally invasive surgery, is an advanced surgical technique used to diagnose and treat various gynecological conditions. Unlike traditional open surgery, it requires only small incisions, resulting in less pain, faster recovery, and minimal scarring.`,

    heroExtraText: `At Dr. Vibha’s Gynecology & Fertility , we specialize in advanced laparoscopic procedures that prioritize safety, fertility preservation, and quicker healing — helping women return to their normal lives with confidence and comfort.`,

    heroImage: fb1,

    sections: [
      {
        medicalheading: "Conditions Treated with Laparoscopic Surgery",
        heading: "Conditions Treated with Laparoscopic Surgery",

        description:
          "Laparoscopy is used to both diagnose and treat a wide range of gynecological conditions.",

        points: [
          "Endometriosis treatment and removal of abnormal tissue",
          "Fibroid removal (Laparoscopic Myomectomy)",
          "Ovarian cyst removal while preserving healthy tissue",
          "Ectopic pregnancy management",
          "Treatment of pelvic adhesions and scar tissue",
          "Laparoscopic hysterectomy when required",
          "Evaluation and treatment of infertility causes",
          "Chronic pelvic pain diagnosis and management",
        ],

        image: fb2,
      },

      {
        heading: "Benefits of Choosing Laparoscopy",

        description:
          "Minimally invasive laparoscopic surgery offers several advantages compared to traditional open procedures.",

        points: [
          "Smaller incisions with minimal scarring",
          "Reduced post-operative pain",
          "Lower risk of infection and complications",
          "Less blood loss during surgery",
          "Shorter hospital stay",
          "Faster recovery and return to daily activities",
          "Better cosmetic results",
          "Improved fertility preservation in eligible cases",
        ],

        image: fb3,
      },

      {
        heading: "Why Choose Dr. Vibha’s  for Laparoscopic Surgery?",

        description:
          "Our  combines advanced surgical expertise with compassionate patient care.",

        points: [
          "Experienced gynecologist trained in advanced laparoscopy",
          "High-definition modern surgical equipment",
          "Personalized surgical planning",
          "Focus on fertility-preserving techniques",
          "Safe anesthesia and monitoring protocols",
          "Comprehensive pre- and post-operative care",
          "Holistic recovery guidance including nutrition and lifestyle support",
        ],

        image: fb4,
      },
    ],

    doctorSection: {
      heading: "How the Laparoscopic Procedure Works",

      para: "The procedure is performed under general anesthesia. A small incision is made near the navel to insert a laparoscope (a thin camera). The abdomen is gently inflated with carbon dioxide to improve visibility. Additional tiny incisions may be made to insert specialized surgical instruments.",

      points: [
        "Most patients are discharged the same day or within 24 hours",
        "Mild bloating or shoulder discomfort may occur temporarily",
        "Normal activities resume within 1–2 weeks",
        "Regular follow-up ensures proper healing",
        "Personalized recovery instructions are provided",
        "Emergency support available if required",
      ],

      image: n3,
    },
  },

  "menstrual-health": {
    title: "Menstrual Health",
    seoTitle:
      "Menstrual Health - Dr Vibha’s  | Expert Gynecological Care",

    seoDescription:
      "Comprehensive menstrual health care at Dr Vibha’s . Expert evaluation, treatment of irregular cycles, pain management, and overall reproductive wellness.",

    seoKeywords:
      "menstrual health, period care, irregular periods, menstrual cycle treatment, gynecologist, reproductive health, Dr Vibha ",

    intro: `Menstrual health is a vital part of women’s overall well-being and reproductive health. A normal cycle usually occurs every 21–35 days, lasting 3–7 days, and reflects proper hormonal balance. Maintaining healthy menstrual cycles helps support fertility, hormonal stability, and overall physical and emotional wellness.`,

    heroExtraText: `When periods are irregular, extremely painful, or unusually heavy, they may indicate conditions such as PCOS, endometriosis, fibroids, or thyroid imbalance. Early medical care ensures accurate diagnosis and effective treatment. At Dr. Vibha’s Gynecology & Fertility , we help women manage menstrual concerns with personalized care, modern diagnostics, and compassionate support.`,

    heroImage: fc1,

    sections: [
      {
        medicalheading: "Common Menstrual Health Concerns We Address",
        heading: "Common Menstrual Health Concerns We Address",

        description:
          "Menstrual irregularities can affect daily life, emotional health, and fertility if left untreated.",

        points: [
          "Irregular periods or unpredictable menstrual cycles",
          "Heavy menstrual bleeding (Menorrhagia)",
          "Painful periods and severe cramps (Dysmenorrhea)",
          "Absence of periods (Amenorrhea)",
          "Premenstrual Syndrome (PMS) and Premenstrual Dysphoric Disorder (PMDD)",
          "Spotting or bleeding between periods",
          "Hormonal imbalance related cycle issues",
          "Menstrual problems associated with PCOS or thyroid disorders",
        ],

        image: fc2,
      },

      {
        heading: "Diagnosis and Medical Evaluation",

        description:
          "Accurate diagnosis helps identify the root cause of menstrual problems and ensures effective treatment.",

        points: [
          "Detailed medical history and symptom evaluation",
          "Pelvic examination if required",
          "Ultrasound scans to detect fibroids, cysts, or uterine conditions",
          "Hormonal blood tests for thyroid, PCOS, or hormone imbalance",
          "Endometrial evaluation when necessary",
          "Cycle tracking and menstrual pattern analysis",
          "Screening for underlying reproductive health conditions",
        ],

        image: fc3,
      },

      {
        heading: "Treatment Options for Menstrual Health",

        description:
          "Treatment plans are personalized based on the underlying condition, symptoms, and overall health.",

        points: [
          "Lifestyle guidance including nutrition, exercise, and stress management",
          "Medications to regulate hormones and reduce pain or heavy bleeding",
          "Hormonal therapies when required",
          "Treatment for PCOS, thyroid disorders, or underlying conditions",
          "Minimally invasive procedures for fibroids, cysts, or polyps",
          "Nutritional support and supplements for anemia or deficiencies",
          "Regular monitoring and follow-up care",
        ],

        image: fc4,
      },
    ],

    doctorSection: {
      heading: "Why Choose Dr. Vibha’s for Menstrual Health Care?",

      para: "We provide compassionate, confidential, and expert care to help women achieve better menstrual health and overall wellness.",

      points: [
        "Experienced gynecologist specializing in menstrual disorders",
        "Advanced diagnostic tools for accurate evaluation",
        "Personalized treatment plans based on individual needs",
        "Focus on long-term hormonal balance and reproductive health",
        "Safe, private, and supportive clinical environment",
        "Comprehensive care from diagnosis to recovery",
      ],

      image: n3,
    },
  },

  "pcos-treatment": {
    title: "PCOS Treatment",
    seoTitle: "PCOS Treatment - Dr Vibha’s  | Hormonal & Fertility Care",

    seoDescription:
      "Expert PCOS treatment at Dr Vibha’s . Personalized care to manage hormonal imbalance, regulate cycles, and improve fertility outcomes.",

    seoKeywords:
      "PCOS treatment, hormonal imbalance treatment, fertility care, irregular periods, PCOD management, gynecologist, Dr Vibha ",

    intro: `Polycystic Ovary Syndrome (PCOS) is a common hormonal disorder affecting women of reproductive age. It occurs when the ovaries produce excess androgens (male hormones), which interfere with normal ovulation. This can lead to irregular menstrual cycles, cyst formation in the ovaries, and various metabolic and reproductive health concerns.`,

    heroExtraText: `PCOS affects more than just periods — it can impact fertility, weight, skin, emotional health, and long-term wellness. At Dr. Vibha’s Gynecology & Fertility , we provide comprehensive and personalized PCOS treatment focused on restoring hormonal balance, improving fertility, and supporting overall health.`,

    heroImage: fd1,

    sections: [
      {
        medicalheading: "Common Symptoms of PCOS",
        heading: "Common Symptoms of PCOS",

        description:
          "PCOS symptoms vary from woman to woman and may develop gradually over time.",

        points: [
          "Irregular, delayed, or missed menstrual periods",
          "Excess facial or body hair growth (hirsutism)",
          "Persistent acne and oily skin",
          "Weight gain, especially around the abdomen",
          "Thinning hair or hair loss from the scalp",
          "Difficulty in conceiving due to irregular ovulation",
          "Darkened skin patches (acanthosis nigricans)",
          "Mood changes, fatigue, and emotional stress",
        ],

        image: fd2,
      },

      {
        heading: "Accurate Diagnosis and Evaluation",

        description:
          "Proper diagnosis is essential for effective PCOS management. Our  uses advanced diagnostic methods combined with personalized consultation.",

        points: [
          "Detailed medical history and symptom review",
          "Physical examination to assess hormonal signs",
          "Pelvic ultrasound to examine ovarian structure",
          "Hormonal blood tests including androgen, estrogen, LH, and FSH levels",
          "Thyroid and metabolic screening",
          "Insulin resistance and diabetes risk evaluation",
          "Comprehensive fertility assessment if required",
        ],

        image: fd3,
      },

      {
        heading: "Personalized PCOS Treatment Options",

        description:
          "Treatment is tailored to each woman’s symptoms, fertility goals, and overall health condition.",

        points: [
          "Lifestyle modifications including diet, exercise, and weight management",
          "Hormonal therapy to regulate menstrual cycles",
          "Medications to reduce excess androgen symptoms like acne and hair growth",
          "Insulin-sensitizing medications such as Metformin when needed",
          "Ovulation induction treatments for women planning pregnancy",
          "Advanced fertility treatments like IUI or IVF if required",
          "Emotional wellness and stress management support",
        ],

        image: fd4,
      },
    ],

    doctorSection: {
      heading: "Why Choose Dr. Vibha’s  for PCOS Treatment?",

      para: "We provide compassionate, science-based, and long-term care to help women manage PCOS effectively and improve their quality of life.",

      points: [
        "Experienced gynecologist specializing in PCOS and hormonal disorders",
        "Advanced diagnostic tools for accurate evaluation",
        "Personalized treatment plans based on individual needs",
        "Focus on fertility preservation and reproductive health",
        "Holistic approach including lifestyle and emotional support",
        "Continuous monitoring and long-term care support",
      ],

      image: n3,
    },
  },

  "pelvic-pain-pap-smear": {
    title: "Pelvic Pain, Breast Examination & Pap Smear",
    seoTitle:
      "Pelvic Pain, Breast Examination & Pap Smear - Dr Vibha’s  | Complete Gynecological Checkup",

    seoDescription:
      "Comprehensive gynecological care at Dr Vibha’s  including pelvic pain management, breast examination, and pap smear screening for early detection and wellness.",

    seoKeywords:
      "pelvic pain treatment, breast examination, pap smear test, gynecological checkup, women's health, early detection, Dr Vibha ",

    intro: `Pelvic pain refers to discomfort in the lower abdomen or pelvic region. It may be occasional or persistent and can result from gynecological, urinary, digestive, or musculoskeletal conditions. While some pelvic pain may be related to normal menstrual cycles, ongoing or severe discomfort should never be ignored. At Dr. Vibha’s Gynecology & Fertility, we focus on identifying the exact cause of pelvic pain and providing personalized treatment to restore comfort, health, and peace of mind.`,

    heroExtraText: `In addition to diagnosing pelvic pain, we also emphasize preventive care through regular breast examinations and Pap smear screening. These essential tests help detect abnormalities early, ensuring timely treatment and long-term reproductive wellness.`,

    heroImage: pa1,

    sections: [
      {
        medicalheading: "Common Causes of Pelvic Pain",
        heading: "Common Causes of Pelvic Pain",

        description:
          "Pelvic pain can originate from various organs and systems within the body. Proper diagnosis is essential for effective treatment.",

        points: [
          "Endometriosis – Growth of uterine tissue outside the uterus causing severe pain and fertility challenges",
          "Ovarian cysts – Fluid-filled sacs that may cause sharp or dull pelvic discomfort",
          "Uterine fibroids – Non-cancerous growths causing pressure, heavy periods, or pain",
          "Pelvic inflammatory disease (PID) – Infection of reproductive organs causing chronic pelvic pain",
          "Urinary tract infections (UTIs) – Burning sensation and lower abdominal discomfort",
          "Digestive disorders such as IBS or constipation causing abdominal and pelvic pressure",
          "Pelvic floor muscle dysfunction causing long-term pelvic discomfort",
        ],

        image: pa2,
      },

      {
        heading: "Effective Treatment Options",

        description:
          "Treatment depends on identifying the root cause. Our  provides comprehensive care to relieve pain and restore normal function.",

        points: [
          "Medications including antibiotics, anti-inflammatory drugs, or hormonal therapy",
          "Pelvic floor physiotherapy to strengthen and relax muscles",
          "Lifestyle guidance including nutrition, stress management, and exercise",
          "Minimally invasive surgery when required for fibroids, cysts, or endometriosis",
          "Long-term monitoring and preventive care to avoid recurrence",
        ],

        image: pa3,
      },

      {
        heading: "Clinical Breast Examination",

        description:
          "Regular breast examinations help detect abnormalities early and protect breast health.",

        points: [
          "Detection of lumps, swelling, or unusual breast changes",
          "Early identification of breast cancer warning signs",
          "Professional evaluation and guidance if abnormalities are found",
          "Recommendation of further imaging like mammography when needed",
          "Preventive screening for long-term breast health",
        ],

        image: pa4,
      },

      {
        heading: "Pap Smear Screening for Cervical Health",

        description:
          "A Pap smear is a simple and effective test used to detect early cervical cell changes before they develop into cancer.",

        points: [
          "Early detection of cervical abnormalities",
          "Prevention and early treatment of cervical cancer",
          "Safe, quick, and painless procedure",
          "Recommended for women starting from age 21",
          "Regular screening ensures long-term reproductive health",
        ],
      },
    ],

    doctorSection: {
      heading:
        "Why Choose Dr. Vibha’s  for Pelvic Pain and Preventive Care",

      para: "We provide comprehensive diagnosis, effective treatment, and preventive screening to ensure complete reproductive wellness.",

      points: [
        "Experienced gynecologist specializing in pelvic pain diagnosis and treatment",
        "Advanced diagnostic technology for accurate evaluation",
        "Personalized treatment plans based on individual needs",
        "Safe and confidential breast examination and Pap smear screening",
        "Compassionate and supportive patient care environment",
        "Continuous follow-up for long-term health and prevention",
      ],

      image: n3,
    },
  },

  "hysterectomy": {
  title: "Hysterectomy Surgery",
  seoTitle:
    "Hysterectomy Surgery - Safe Uterus Removal | Dr Vibha’s ",

  seoDescription:
    "Expert hysterectomy surgery at Dr Vibha’s  for fibroids, heavy bleeding, and other conditions with advanced and safe techniques.",

  seoKeywords:
    "hysterectomy surgery, uterus removal, fibroids treatment, heavy bleeding treatment, gyne surgery, Dr Vibha ",

  intro: `Hysterectomy is a surgical procedure to remove the uterus. It is recommended in cases of severe gynecological conditions such as fibroids, abnormal bleeding, endometriosis, or cancer. At Dr. Vibha’s Gynecology & Fertility, we perform safe and advanced hysterectomy procedures with a focus on faster recovery and patient comfort.`,

  heroExtraText: `Our goal is to provide a smooth surgical experience with minimal pain, faster healing, and long-term relief from symptoms affecting your quality of life.`,

  heroImage: hyst1,

  sections: [
    {
      heading: "When is Hysterectomy Needed?",
      description:
        "Hysterectomy is recommended when other treatments fail or the condition is severe.",
      points: [
        "Large or multiple uterine fibroids",
        "Heavy or uncontrolled menstrual bleeding",
        "Chronic pelvic pain",
        "Endometriosis not responding to treatment",
        "Uterine prolapse or cancer",
      ],
      image: hyst2,
    },
    {
      heading: "Types of Hysterectomy",
      description:
        "Different types are performed based on the medical condition.",
      points: [
        "Total hysterectomy – removal of uterus and cervix",
        "Partial hysterectomy – removal of uterus only",
        "Laparoscopic hysterectomy – minimally invasive procedure",
        "Abdominal hysterectomy – for complex cases",
      ],
      image: hyst3,
    },
    {
      heading: "Recovery & Care",
      description:
        "Proper care ensures smooth recovery and long-term health.",
      points: [
        "Hospital stay of 1–3 days depending on procedure",
        "Avoid heavy lifting for few weeks",
        "Follow-up consultations for monitoring recovery",
        "Gradual return to normal activities",
      ],
    },
  ],

  doctorSection: {
    heading:
      "Why Choose Dr. Vibha’s  for Hysterectomy",
    para: "We ensure safe surgery with modern techniques and personalized care.",
    points: [
      "Experienced gynecological surgeon",
      "Advanced minimally invasive techniques",
      "High success rate with quick recovery",
      "Personalized pre and post-surgery care",
      "Comfortable and safe environment",
    ],
    image: n3,
  },
},

"myomectomy": {
  title: "Myomectomy Surgery",
  seoTitle:
    "Myomectomy Surgery - Fibroid Removal Without Uterus Removal | Dr Vibha’s ",

  seoDescription:
    "Safe and advanced myomectomy surgery at Dr Vibha’s  to remove fibroids while preserving the uterus and fertility.",

  seoKeywords:
    "myomectomy surgery, fibroid removal, uterus preservation, fertility treatment, gyne surgery, Dr Vibha ",

  intro: `Myomectomy is a surgical procedure used to remove uterine fibroids while preserving the uterus. It is ideal for women who want relief from fibroid symptoms but wish to maintain fertility. "At  Dr. Vibha’s Gynecology & Fertility 
  ", we offer advanced myomectomy procedures with a focus on safety, precision, and faster recovery.`,

  heroExtraText: `Our approach ensures effective removal of fibroids while maintaining reproductive health, helping women live comfortably and plan future pregnancies with confidence.`,

  heroImage: myo1,

  sections: [
    {
      heading: "When is Myomectomy Needed?",
      description:
        "Myomectomy is recommended when fibroids cause significant symptoms or complications.",
      points: [
        "Heavy or prolonged menstrual bleeding",
        "Pelvic pain or pressure",
        "Difficulty in conceiving due to fibroids",
        "Frequent urination caused by fibroid pressure",
        "Rapid growth of fibroids",
      ],
      image: myo2,
    },
    {
      heading: "Types of Myomectomy",
      description:
        "Different techniques are used depending on the size, number, and location of fibroids.",
      points: [
        "Laparoscopic myomectomy – minimally invasive with faster recovery",
        "Hysteroscopic myomectomy – for fibroids inside the uterus",
        "Open abdominal myomectomy – for large or multiple fibroids",
      ],
      image: myo3,
    },
    {
      heading: "Recovery & Benefits",
      description:
        "Proper care after surgery ensures smooth healing and long-term results.",
      points: [
        "Preserves uterus and fertility",
        "Relief from heavy bleeding and pain",
        "Short hospital stay (depending on procedure)",
        "Gradual return to normal activities",
        "Regular follow-up to monitor recovery",
      ],
    },
  ],

  doctorSection: {
    heading:
      "Why Choose Dr. Vibha’s  for Myomectomy",
    para: "We focus on safe fibroid removal while protecting your future fertility.",
    points: [
      "Experienced gynecological surgeon",
      "Advanced minimally invasive techniques",
      "Fertility-preserving approach",
      "High success rate with personalized care",
      "Comprehensive post-surgery support",
    ],
    image: n3,
  },
},

"colposcopy": {
  title: "Colposcopy Examination",
  seoTitle:
    "Colposcopy Test - Cervical Examination & Early Detection | Dr Vibha’s ",

  seoDescription:
    "Accurate colposcopy examination at Dr Vibha’s  for detecting cervical abnormalities after abnormal pap smear results.",

  seoKeywords:
    "colposcopy test, cervical examination, abnormal pap smear, cervical screening, women's health, Dr Vibha ",

  intro: `Colposcopy is a diagnostic procedure used to closely examine the cervix, vagina, and vulva for signs of disease. It is usually recommended after an abnormal Pap smear result. At Dr. Vibha’s Gynecology & Fertility , we perform safe and precise colposcopy examinations for early detection and timely treatment.`,

  heroExtraText: `Early diagnosis through colposcopy helps prevent serious conditions like cervical cancer and ensures better reproductive health outcomes.`,

  heroImage: colpo1,

  sections: [
    {
      heading: "When is Colposcopy Recommended?",
      description:
        "Colposcopy is advised when there are abnormal findings or symptoms.",
      points: [
        "Abnormal Pap smear results",
        "Unusual vaginal bleeding",
        "Persistent cervical infections",
        "Visible abnormalities on cervix",
        "Follow-up after HPV infection detection",
      ],
      image: colpo2,
    },
    {
      heading: "Procedure & What to Expect",
      description:
        "Colposcopy is a simple and quick outpatient procedure.",
      points: [
        "Takes about 10–20 minutes",
        "A special microscope (colposcope) is used for detailed view",
        "Mild discomfort may be felt but generally painless",
        "Biopsy may be taken if needed for further testing",
      ],
      image: colpo3,
    },
    {
      heading: "Benefits of Colposcopy",
      description:
        "Early detection helps in better treatment and prevention.",
      points: [
        "Detects precancerous changes early",
        "Helps prevent cervical cancer",
        "Guides accurate treatment decisions",
        "Safe and minimally invasive procedure",
      ],
    },
  ],

  doctorSection: {
    heading:
      "Why Choose Dr. Vibha’s  for Colposcopy",
    para: "We ensure accurate diagnosis with patient comfort and safety.",
    points: [
      "Experienced gynecologist for cervical screening",
      "Advanced diagnostic equipment",
      "Safe and hygienic environment",
      "Personalized guidance after diagnosis",
      "Complete follow-up care and support",
    ],
    image: n3,
  },
},

"cryo-cautery": {
  title: "Cryo Cautery Treatment",
  seoTitle:
    "Cryo Cautery Treatment - Cervical Cell Treatment | Dr Vibha’s ",

  seoDescription:
    "Safe and effective cryo cautery treatment at Dr Vibha’s  for removing abnormal cervical cells and preventing complications.",

  seoKeywords:
    "cryo cautery, cervical treatment, abnormal cells removal, cervix treatment, gyne procedure, Dr Vibha ",

  intro: `Cryo cautery is a simple and effective procedure used to treat abnormal or infected cervical cells by freezing them. It is commonly recommended for cervical erosion, chronic infections, or abnormal findings after screening tests. At Dr. Vibha’s Gynecology & Fertility , we provide safe and painless cryo cautery treatment with a focus on quick recovery and long-term cervical health.`,

  heroExtraText: `This minimally invasive procedure helps restore healthy cervical tissue and prevents further complications, ensuring better reproductive wellness.`,

  heroImage: cryo1,

  sections: [
    {
      heading: "When is Cryo Cautery Needed?",
      description:
        "Cryo cautery is recommended in specific cervical conditions.",
      points: [
        "Cervical erosion (cervicitis)",
        "Chronic vaginal discharge due to infection",
        "Abnormal cervical cell changes",
        "Post abnormal Pap smear findings",
        "Mild precancerous cervical conditions",
      ],
      image: cryo2,
    },
    {
      heading: "Procedure & What to Expect",
      description:
        "Cryo cautery is a quick and minimally invasive outpatient procedure.",
      points: [
        "Takes around 10–15 minutes",
        "Uses extreme cold to destroy abnormal cells",
        "Usually painless with mild discomfort",
        "No hospital stay required",
        "Normal activities can be resumed quickly",
      ],
      image: cryo3,
    },
    {
      heading: "Recovery & Benefits",
      description:
        "Proper care ensures fast healing and effective results.",
      points: [
        "Quick healing of cervical tissue",
        "Relief from discharge and infection",
        "Prevents progression of abnormal cells",
        "Safe and effective treatment",
        "Minimal downtime and complications",
      ],
    },
  ],

  doctorSection: {
    heading:
      "Why Choose Dr. Vibha’s  for Cryo Cautery",
    para: "We provide safe, precise, and comfortable treatment for cervical health.",
    points: [
      "Experienced gynecologist for cervical procedures",
      "Advanced and safe treatment methods",
      "Quick and painless procedure",
      "Hygienic and patient-friendly environment",
      "Complete follow-up and care guidance",
    ],
    image: n3,
  },
}

};
